import { ConceptType } from "../constants";

 export function isConceptTypeValid(activeConceptList) {
    return Object.values(ConceptType).includes(activeConceptList);
}